import moment from "moment";
import React, { useEffect, useState } from "react";
import { Badge, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router-dom";
import Loader from "../../../../components/Common/Loader";
import Toggle from "../../../../components/Common/Toggle";
import TableLayout from "../../../../components/TableLayout";
import {
  HOTEL_ADMIN_APPROVE_REJECT,
  HOTEL_STATUS_CHANGE,
  HOTELADMINBLOCKUNBLOC,
  HOTELADMINVERIFYUNVERIFY,
  SINGLEHOTELADMIN
} from "../../../../services/ApiCalls";
import { catchAsync, checkResponse } from "../../../../utilities/utilities";
const ManageserviceDataDetail = () => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const [serviceData, setServiceData] = useState();
  const [filter, setFilter] = useState({
    limit: 10,
    page: 1,
  });
  const { id } = useParams();
  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await SINGLEHOTELADMIN({ id: id });
    checkResponse({ res, setData: setServiceData, setLoader });
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const columns = [
    {
      head: t("manageHotel.columns.serialNumber"),
      accessor: "#",
      component: (item, key) => {
        return <>{filter.limit * (filter.page - 1) + key + 1}</>;
      },
    },
    {
      head: t("manageHotel.columns.hotelName"),
      accessor: "hotelName",
      component: (item) => (
        <>
          {item.hotelName
            ? item.hotelName
            : t("manageHotel.placeholders.notAvailable")}
        </>
      ),
    },
    {
      head: t("manageHotel.columns.hotelId"),
      accessor: "hotelId",
      component: (item) => (
        <>
          {item.hotelId
            ? item.hotelId
            : t("manageHotel.placeholders.notAvailable")}
        </>
      ),
    },
    {
      head: t("manageHotel.columns.hotelPriority"),
      accessor: "label",
      component: (item) => (
        <>
          {item.pinStatus
            ? item.pinStatus?.label
            : t("manageHotel.placeholders.notAvailable")}
        </>
      ),
    },
    {
      head: t("manageHotel.columns.totalRooms"),
      accessor: "totalRoom",
      component: (item) => (
        <>
          {item?.totalRoom
            ? item?.totalRoom
            : t("manageHotel.placeholders.notAvailable")}
        </>
      ),
    },
    {
      head: t("manageHotel.columns.adminName"),
      accessor: "name",
      component: (item) => (
        <>
          {item.userDetail?.name
            ? item.userDetail?.name
            : t("manageHotel.placeholders.notAvailable")}
        </>
      ),
    },
    {
      head: t("manageHotel.columns.mobileNumber"),
      accessor: "mobileNumber",
      component: (item) => (
        <span className="text-nowrap">
          {item?.countryCode
            ? `+${item.countryCode} ${item?.mobileNumber}`
            : item?.mobileNumber || t("manageHotel.placeholders.notAvailable")}
        </span>
      ),
    },
    {
      head: t("manageHotel.columns.email"),
      accessor: "email",
      component: (item) => (
        <span className="text-wrap">
          {item?.email
            ? item.email
            : t("manageHotel.placeholders.notAvailable")}
        </span>
      ),
    },
    {
      head: t("manageHotel.columns.location"),
      accessor: "address",
      component: (item) => {
        const words = item?.address?.split(" ");
        const truncatedText = words?.slice(0, 4).join(" ");
        const displayText =
          words?.length > 1
            ? `${truncatedText}...`
            : truncatedText || t("manageHotel.placeholders.notAvailable");
        return <span title={item?.address}>{displayText}</span>;
      },
    },
    {
      head: t("manageHotel.columns.createdAt"),
      accessor: "createdAt",
      component: (item) => (
        <>
          {item.createdAt
            ? moment(item.createdAt).format("MM-DD-YYYY , HH:mm")
            : t("manageHotel.placeholders.notAvailable")}
        </>
      ),
    },
    {
      head: t("manageHotel.columns.status"),
      accessor: "status",
      title: t("manageHotel.statusTooltip"),
      component: (item, key) => <span className="">{item?.status}</span>,
    },
  ];

  return (
    <>
      {loader && <Loader />}
      <section className="serviceDetail py-3 position-relative">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12">
              <div className="d-flex align-items-center gap-2 mb-3">
                <Link
                  to={`/manage-hotel-admin?page=${page}`}
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      strokeWidth="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 fw-bold text-dark">
                  {t("manageHotelAdmin.form.detail")}
                </h4>
              </div>
            </Col>

            <Col lg="4" className="my-2">
              <div className="cardCstm text-center px-3 py-4 rounded shadow-sm h-100">
                <img
                  src={
                    serviceData?.profileImage ||
                    "https://via.placeholder.com/150?text=No+Image"
                  }
                  alt="Profile"
                  className="rounded-circle mb-3"
                  style={{ width: 120, height: 120, objectFit: "cover" }}
                />
                <h5 className="fw-bold text-capitalize">{serviceData?.name}</h5>
                <p className="text-muted mb-1">{serviceData?.email}</p>
                <p className="text-muted mb-2">
                  {serviceData?.countryCode} {serviceData?.mobileNumber}
                </p>
                {!loader && (
                  <div className="d-flex align-items-center gap-2 justify-content-center">
                    <Badge
                      bg={serviceData?.status === "Active" ? "success" : "warning"}
                    >
                      {serviceData?.status}
                    </Badge>

                    <Badge bg={serviceData?.isVarified ? "success" : "danger"}>
                      {serviceData?.isVarified ? t("common.verified", "Verified") :
                        t("common.notVerified", "Not Verified")}
                    </Badge>
                  </div>
                )}

                {/* {
                  !loader && !serviceData?.isVarified && (
                    <div className="d-flex align-items-center justify-content-center mt-2">
                      <Toggle
                        checked={serviceData?.isVarified}
                        onChange={catchAsync(async () => {
                          if (!serviceData?._id) return;
                          setLoader(true);

                          const updatedStatus =
                            !serviceData.isVarified
                          const res = await HOTELADMINVERIFYUNVERIFY({
                            id: id,
                          });

                          const success = checkResponse({ res, showSuccess: true });
                          if (success) {
                            setServiceData({
                              ...serviceData,
                              isVarified: true
                            });
                          }
                          setLoader(false);
                        })}
                      />
                      <span className="ms-2 fw-bold">
                        {t("common.verifyHotelAdmin", "Verify Hotel Admin")}
                      </span>
                    </div>)} */}
                <div className="d-flex align-items-center justify-content-center mt-2">
                  <Toggle
                    isChecked={serviceData?.status === "Active"}

                    onChange={catchAsync(async () => {
                      if (!serviceData?._id) return;
                      setLoader(true);

                      const updatedStatus =
                        serviceData.status === "Active" ? "Inactive" : "Active";

                      const res = await HOTELADMINBLOCKUNBLOC({
                        id: id,
                        status: updatedStatus,
                      });

                      const success = checkResponse({ res, showSuccess: true });
                      if (success) {
                        setServiceData({
                          ...serviceData,
                          status: updatedStatus,
                        });
                      }
                      setLoader(false);
                    })}
                  />
                  <span className="ms-2 fw-bold">
                    {t("common.blockUnblockHotelAdmin",)}
                  </span>
                </div>
                 {!loader&&!serviceData?.isVarified&&<div className="d-flex align-items-center justify-content-center mt-2">
               <button className="btn-primary" onClick={catchAsync(async () => {
                      if (!serviceData?._id) return;
                      setLoader(true);

                      const updatedStatus =
                        serviceData.status  ? false : true;

                      const res = await HOTEL_STATUS_CHANGE({
                        id: id,
                        status: updatedStatus,
                      });

                      const success = checkResponse({ res, showSuccess: true });
                      if (success) {
                        setServiceData({
                          ...serviceData,
                          isVarified: true,
                        });
                      }
                      setLoader(false);
                    })}> {t("common.verifyHotelAdmin",)}</button>
                 
                </div>}
              </div>
            </Col>

            <Col lg="8" className="my-2">
              <div className="cardCstm px-4 py-3 rounded shadow-sm">
                <h5 className="fw-bold mb-3">
                  {t("manageHotelAdmin.form.personalInfo")}
                </h5>
                <Row>
                  <Col md="6">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.columns.address")}
                    </p>
                    <p className="text-muted">{serviceData?.address}</p>
                  </Col>
                  <Col md="6">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.columns.location")}
                    </p>
                    <p className="text-muted">
                      {serviceData?.city}, {serviceData?.state},{" "}
                      {serviceData?.country}
                    </p>
                  </Col>
                  <Col md="6">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.columns.role")}
                    </p>
                    <p className="text-muted">{serviceData?.role}</p>
                  </Col>
                  <Col md="6">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.columns.onlineStatus")}
                    </p>
                    <p
                      className={
                        serviceData?.onlineStatus
                          ? "text-success fw-bold"
                          : "text-danger fw-bold"
                      }
                    >
                      {serviceData?.onlineStatus
                        ? t("common.online")
                        : t("common.offline")}
                    </p>
                  </Col>
                  <Col md="12">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.form.description")}
                    </p>
                    <p className="text-muted">{serviceData?.description}</p>
                  </Col>
                  <Col md="12">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.form.totalHotel")}
                    </p>
                    <p className="text-muted">{serviceData?.totalHotel}</p>
                  </Col>
                </Row>
              </div>

              <div className="cardCstm px-4 py-3 rounded shadow-sm mt-3">
                <h5 className="fw-bold mb-3">
                  {t("manageHotelAdmin.form.accountInfo")}
                </h5>
                <Row>
                  <Col md="6">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.form.walletBalance")}
                    </p>
                    <p className="text-muted">{serviceData?.walletCredit}</p>
                  </Col>
                  <Col md="6">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.form.points")}
                    </p>
                    <p className="text-muted">{serviceData?.points}</p>
                  </Col>
                  <Col md="6">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.form.stripeConnect")}
                    </p>
                    <p className="text-muted">
                      {serviceData?.stripeConnectStatus
                        ? t("common.connected")
                        : t("common.notConnected")}
                    </p>
                  </Col>
                  <Col md="6">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.columns.avgRating")}
                    </p>
                    <p className="text-muted">{serviceData?.avgRating} ⭐</p>
                  </Col>
                  <Col md="12">
                    <p className="fw-bold mb-1">
                      {t("manageHotelAdmin.columns.accountCreatedAt")}
                    </p>
                    <p className="text-muted">
                      {moment(serviceData?.createdAt).format(
                        "DD-MM-YYYY, HH:mm"
                      )}
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <strong>{t("manageHotelAdmin.form.hotelList")}</strong>
              <TableLayout
                column={columns}
                data={serviceData?.hotelList}
                loader={loader}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageserviceDataDetail;
